import Component from './Locale.component';
import { connect } from 'react-redux';
import { shouldRetranslate } from '/b2b/common/state/locale/Locale.selectors';

export const mapStateToProps = state => ({
    shouldRetranslate: shouldRetranslate(state),
});

/** @type {React.FC<import('./Locale.component').LocaleProps>} */
export default connect(mapStateToProps)(Component);
